

















import AllServices from "@/components/landing-page/AllServices.vue";
import ScrollToTopButton from "@/components/landing-page/ScrollToTopButton.vue";
import TopCarousel from "@/components/landing-page/TopCarousel.vue";
import EnglishLang from "../../public/languages/English.json";

export default {
  name: "LandingPage",
  components: {
    AllServices,
    ScrollToTopButton,
    TopCarousel
  },
  data: function() {
    return {
      englishLang: EnglishLang
    };
  }
};
